import { render } from "./GenericModalComponent.vue?vue&type=template&id=54a55125&scoped=true"
import script from "./GenericModalComponent.vue?vue&type=script&lang=js"
export * from "./GenericModalComponent.vue?vue&type=script&lang=js"

import "./GenericModalComponent.vue?vue&type=style&index=0&id=54a55125&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a55125"]])

export default __exports__